import "@/goldhunter/goldhunter.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Nav from "@/goldhunter/components/Nav";
import Dashboard from "@/goldhunter/pages/Dashboard";
import GoldHunter from "@/goldhunter/pages/GoldHunter";
import Treasury from "@/goldhunter/pages/Treasury";
import ControlRoom from "@/goldhunter/pages/ControlRoom";
import StrikeDeck from "@/goldhunter/pages/StrikeDeck";
import Rover from "@/goldhunter/pages/Rover";
import CapitalColony from "@/goldhunter/pages/CapitalColony";
import LegalColony from "@/goldhunter/pages/LegalColony";
import PartnerView from "@/goldhunter/pages/PartnerView";
import PaymentSuccess from "@/goldhunter/pages/PaymentSuccess";
import Profile from "@/goldhunter/pages/Profile";

// Legacy "YABAI Gold-Hunter" app, mounted under /gold/* alongside YABBAI Orchestra.
// It deliberately does NOT create its own BrowserRouter — it renders nested routes
// inside the shared router from src/App.js. All routes are relative to /gold.
export default function GoldHunterApp() {
  return (
    <div
      className="goldhunter-root"
      style={{ minHeight: "100vh", background: "var(--yb-bg)", color: "var(--yb-text-primary)" }}
    >
      <Nav />
      <main className="pb-20">
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="gold-hunter" element={<GoldHunter />} />
          <Route path="treasury" element={<Treasury />} />
          <Route path="control-room" element={<ControlRoom />} />
          <Route path="strike-deck" element={<StrikeDeck />} />
          <Route path="rover" element={<Rover />} />
          <Route path="capital-colony" element={<CapitalColony />} />
          <Route path="legal-colony" element={<LegalColony />} />
          <Route path="partner-view" element={<PartnerView />} />
          <Route path="payment-success" element={<PaymentSuccess />} />
          <Route path="profile" element={<Profile />} />
          <Route path="*" element={<Navigate to="/gold" replace />} />
        </Routes>
      </main>
      <footer
        className="py-6 text-center text-[12px]"
        style={{
          borderTop: "1px solid var(--yb-border-soft)",
          color: "var(--yb-text-muted)",
          background: "var(--yb-surface-1)",
          fontFamily: "'Google Sans', Roboto, sans-serif",
        }}
      >
        YABAI · Gold-Hunter Swarm · Sentinel · Scraper · Janitor · 24/7
      </footer>
    </div>
  );
}
